import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {FONT_WEIGHT_PROXIMA_SEMIBOLD, LEGACY_FONT_PROXIMA_15} from 'styles/FontConstants';
import {GRAY_DARK, GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function DiagramError({errorMessage}: {errorMessage: string}): JSX.Element {
  return (
    <div className={classNames(css(styles.wrapper), 'u-text-align-center')} role="alert">
      <BenchlingIcon icon="warning" className={classNames(css(styles.icon))} />
      <div className={css(styles.errorText)}>{errorMessage}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: '16px',
  },
  icon: {
    color: GRAY_LIGHT,
    height: '60px',
    width: '60px',
  },
  errorText: {
    ...LEGACY_FONT_PROXIMA_15,
    color: GRAY_DARK,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
});
